import React from 'react';
import { useTranslation } from 'react-i18next';
import { ZoneWrapper, Places, ZoneId } from './Zone.styled';

function Zone(props) {
  const { t } = useTranslation();
  //console.log('🚀 ~ Zone ~ props', props);
  return (
    <ZoneWrapper left={props.left} top={props.top}>
      <ZoneId color={props.color}>{props.caption}</ZoneId>
      <Places show={props.showPlaces} color={props.color}>
        {props.places || 0} {t('windows.мест')}
      </Places>
    </ZoneWrapper>
  );
}

export default Zone;
